var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"provider_new\"\u003E\u003Cprovider-form :errors=\"errors\" @submit=\"createProvider\"\u003E\u003C\u002Fprovider-form\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;